import { createClient } from '@supabase/supabase-js'

const supabaseUrl = (import.meta as any).env.VITE_SUPABASE_URL
const supabaseServiceRoleKey = (import.meta as any).env.VITE_SUPABASE_SERVICE_ROLE_KEY

// Check if admin environment variables are configured
const isAdminConfigured = supabaseUrl && 
  supabaseServiceRoleKey && 
  supabaseUrl !== 'https://your-project-id.supabase.co' && 
  supabaseServiceRoleKey !== 'your-service-role-key-here'

if (!isAdminConfigured) {
  console.warn('⚠️  Supabase Admin is not configured. Admin features may not work properly.')
  console.warn('📝 Make sure VITE_SUPABASE_SERVICE_ROLE_KEY is set in your environment variables.')
  console.warn('🔍 Current values:', { 
    url: supabaseUrl, 
    hasServiceKey: !!supabaseServiceRoleKey,
    serviceKeyLength: supabaseServiceRoleKey?.length || 0
  })
} else {
  console.log('✅ Supabase Admin client configured successfully!')
}

// Create admin client with service role key (bypasses RLS)
export const supabaseAdmin = isAdminConfigured 
  ? createClient(supabaseUrl, supabaseServiceRoleKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false
      }
    })
  : null

// Helper function to check if admin client is available
export const isAdminAvailable = () => {
  return supabaseAdmin !== null
}

// Helper function to get admin client with error handling
export const getAdminClient = () => {
  if (!supabaseAdmin) {
    throw new Error('Supabase admin client is not configured. Please set VITE_SUPABASE_SERVICE_ROLE_KEY environment variable.')
  }
  return supabaseAdmin
} 